module.exports = __webpack_public_path__ + "img/engineering1.6a5a333f.png";